/** Niveles de seguro alineados con BD insurances + booking.r_insurance_id */
export const INSURANCE_REGULAR = 2;
export const INSURANCE_VIP_BASIC = 4;
export const INSURANCE_VIP_PREMIUM = 1;

export const MIN_DAYS_VIP_BASIC = 2;
export const MIN_DAYS_VIP_PREMIUM = 4;

export const normalizeInsuranceId = raw => {
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    if (raw.value != null) return normalizeInsuranceId(raw.value);
    if (raw.id != null) return normalizeInsuranceId(raw.id);
  }
  const n = Number(raw);
  if (
    n === INSURANCE_VIP_PREMIUM ||
    n === INSURANCE_VIP_BASIC ||
    n === INSURANCE_REGULAR
  ) {
    return n;
  }
  // Legacy boolean: true → VIP Premium (el único VIP histórico)
  if (raw === true || raw === "true") {
    return INSURANCE_VIP_PREMIUM;
  }
  return INSURANCE_REGULAR;
};

/**
 * Identifica el seguro real (legacy boolean + id nuevo).
 *
 * 1) r_insurance_id ∈ {1,4} → verdad (sistema nuevo)
 * 2) r_insurance ∈ {1,4} y id Regular/null → id metido en boolean
 * 3) r_insurance truthy y id Regular/null → VIP Premium histórico
 * 4) resto → Regular
 *
 * Producción: bookings viejos solo con boolean siguen resolviendo a Premium;
 * bookings nuevos con Basic (4) no se confunden con Premium.
 */
export const resolveBookingInsuranceId = booking => {
  if (!booking) return INSURANCE_REGULAR;
  const idRaw = booking.r_insurance_id;
  const flag = booking.r_insurance;
  const idNum = idRaw != null && idRaw !== "" ? Number(idRaw) : null;
  const flagNum = flag != null && flag !== "" ? Number(flag) : null;

  if (idNum === INSURANCE_VIP_PREMIUM || idNum === INSURANCE_VIP_BASIC) {
    return idNum;
  }
  if (
    (flagNum === INSURANCE_VIP_PREMIUM || flagNum === INSURANCE_VIP_BASIC) &&
    (idNum == null || Number.isNaN(idNum) || idNum === INSURANCE_REGULAR)
  ) {
    return flagNum;
  }
  const legacyVipFlag =
    flag === true || flag === "true" || flag === 1 || flag === "1";
  if (
    legacyVipFlag &&
    (idNum == null || Number.isNaN(idNum) || idNum === INSURANCE_REGULAR)
  ) {
    return INSURANCE_VIP_PREMIUM;
  }
  if (idNum === INSURANCE_REGULAR) return INSURANCE_REGULAR;
  return INSURANCE_REGULAR;
};

export const isPaidInsurance = insuranceId => {
  const id = normalizeInsuranceId(insuranceId);
  return id === INSURANCE_VIP_PREMIUM || id === INSURANCE_VIP_BASIC;
};

/** Si no cumple mín. días → Regular */
export const resolveApplicableInsuranceId = (requestedId, days) => {
  const id = normalizeInsuranceId(requestedId);
  const d = Number(days) || 0;
  if (id === INSURANCE_VIP_PREMIUM) {
    return d >= MIN_DAYS_VIP_PREMIUM ? INSURANCE_VIP_PREMIUM : INSURANCE_REGULAR;
  }
  if (id === INSURANCE_VIP_BASIC) {
    return d >= MIN_DAYS_VIP_BASIC ? INSURANCE_VIP_BASIC : INSURANCE_REGULAR;
  }
  return INSURANCE_REGULAR;
};

export const insuranceLabel = insuranceId => {
  const id = normalizeInsuranceId(insuranceId);
  if (id === INSURANCE_VIP_PREMIUM) return "VIP Premium";
  if (id === INSURANCE_VIP_BASIC) return "VIP Basic";
  return "Regular";
};

/** Opciones Select/radio admin (value = id BD). */
export const insuranceSelectChoices = (extrasDays = 0) => {
  const d = Number(extrasDays) || 0;
  return [
    { id: INSURANCE_REGULAR, name: "Regular Insurance" },
    {
      id: INSURANCE_VIP_BASIC,
      name: "VIP Basic",
      disabled: d < MIN_DAYS_VIP_BASIC,
    },
    {
      id: INSURANCE_VIP_PREMIUM,
      name: "VIP Premium",
      disabled: d < MIN_DAYS_VIP_PREMIUM,
    },
  ];
};

/** Precio diario desde lista prices (price_item_type insurance). Sin fila → 0. */
export const dailyInsurancePriceFromList = (insurancePrices, insuranceId) => {
  const id = normalizeInsuranceId(insuranceId);
  if (id === INSURANCE_REGULAR) return 0;
  if (!insurancePrices || !insurancePrices.length) return 0;
  const rows = insurancePrices
    .filter(
      p =>
        (p.price_item_type == null || p.price_item_type === "insurance") &&
        Number(p.price_item_id) === id &&
        (p.percentage == null || Number(p.percentage) === 0) &&
        p.price != null
    )
    .slice()
    .sort((a, b) => {
      const da = a.start_date ? new Date(a.start_date).getTime() : 0;
      const db = b.start_date ? new Date(b.start_date).getTime() : 0;
      return db - da;
    });
  const row = rows[0];
  return row && row.price != null ? Number(row.price) : 0;
};



// WEBPACK FOOTER //
// ./src/util/rentalInsurance.js